import React from 'react'

import { Formik } from 'formik'

import { Form, Modal, Button } from '_zari/core'

import * as Sections from '../_shared/sections'

const PorDefectoModal = ({ show, handleClose, modalData, submitFunction }) => {
  const formInitialValues = React.useMemo(() => {
    return modalData
  }, [modalData])

  const onSubmit = React.useCallback(
    data => {
      submitFunction({
        ...data,
        modalValido: true
      })
    },
    [submitFunction]
  )

  return (
    <Modal show={show} centered>
      <Modal.Header>
        <Modal.Title>EDICION AVANZADA</Modal.Title>
      </Modal.Header>
      <Formik initialValues={formInitialValues} onSubmit={onSubmit}>
        {({
          errors,
          touched,
          isSubmitting,
          values,
          handleSubmit,
          handleChange,
          setFieldValue,
          setValues
        }) => (
          <>
            <Modal.Body>
              <Form>
                <Sections.ComunSection
                  errors={errors}
                  touched={touched}
                  isSubmitting={isSubmitting}
                  handleChange={handleChange}
                  values={values}
                  setFieldValue={setFieldValue}
                  setValues={setValues}
                  nextNodeId='button-porDefectocomodal-procesar'
                />
              </Form>
            </Modal.Body>
            <Modal.Footer>
              <Button color='secondary' onClick={handleClose} disabled={isSubmitting}>
                Cancelar
              </Button>
              <Button
                id='button-porDefectocomodal-procesar'
                onClick={handleSubmit}
                disabled={isSubmitting}
              >
                Guardar
              </Button>
            </Modal.Footer>
          </>
        )}
      </Formik>
    </Modal>
  )
}

export default React.memo(PorDefectoModal)
